import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_bin",
  "use": "icon_bin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_bin\"><path d=\"M4 6.778h17m-15.111 0V20c0 1.043.846 1.889 1.889 1.889h9.444A1.889 1.889 0 0019.112 20V6.778m-10.39 0v-1.89c0-1.042.846-1.888 1.89-1.888h3.777c1.043 0 1.889.846 1.889 1.889v1.889M14.389 11.5v5.667M10.611 11.5v5.667\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol